var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ProductionDemandSpreadSheet } from 'components/Planning/ProductionDemandSpreadSheet';
var AdminView = function (_a) {
    var onClose = _a.onClose;
    return (_jsx("div", __assign({ className: "flex flex-col overflow-hidden p-7" }, { children: _jsx(ProductionDemandSpreadSheet, { onClose: onClose }) })));
};
export default AdminView;
